import React from 'react';
import Header from './Header';
import Footer from './Footer';
import Animation from '../animation/animation';

const TermsAndConditionsPage = () => {
  const sections = [
    {
      title: "General Rules",
      content: [
        "Participants must follow the code of conduct at all times.",
        "Decisions made by the judges and organizers are final and binding.",
        "Any form of plagiarism or cheating will lead to immediate disqualification."
      ]
    },
    {
      title: "Project Submission & Usage",
      content: [
        "All projects must be developed during the official hackathon timeline.",
        "Projects created or submitted during the event may be used by the event team for sponsorship-related activities and promotional tasks.",
        "Participants retain the intellectual property rights to their original work, but grant the organizers a non-exclusive license to showcase the projects."
      ]
    },
    {
      title: "Eligibility",
      content: [
        "The event is open to students and enthusiasts globally.",
        "Participants under 18 must provide parental consent for physical attendance (if applicable)."
      ]
    }
  ];

  return (
    <div className="terms-page relative overflow-x-hidden min-h-screen flex flex-col">
      <div className="fixed top-0 left-0 w-full h-screen z-0 pointer-events-none">
        <Animation className="w-full h-full" />
        <div 
          className="absolute inset-0 w-full h-full"
          style={{
            background: 'linear-gradient(to bottom, rgba(0,0,0,0) 40%, rgba(0,0,0,0.1) 55%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0.6) 85%, rgba(0,0,0,1) 100%)'
          }}
        />
      </div>
      <Header />
      <main className="w-[95%] max-w-[1000px] mx-auto relative z-10 pt-40 px-6 md:px-10 flex flex-col items-center justify-start bg-transparent pb-20">
        <h1 className="text-4xl md:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#E61933] to-[#FF33CC] font-['Inter'] text-center mb-12 drop-shadow-[0_2px_10px_rgba(230,25,51,0.3)]">
          Terms & Conditions
        </h1>
        
        <div className="backdrop-blur-md bg-white/5 border border-white/10 rounded-2xl p-8 md:p-12 shadow-[0_8px_32px_rgba(0,0,0,0.3)] w-full">
          <div className="text-white/80 font-['Poppins'] text-base md:text-lg leading-relaxed space-y-10">
            {sections.map((section, idx) => (
              <div key={idx} className="space-y-4">
                <h2 className="text-2xl font-bold text-white border-b border-white/10 pb-2">{section.title}</h2>
                <ul className="list-disc list-inside space-y-3 pl-4">
                  {section.content.map((item, i) => (
                    <li key={i} className="text-justify">{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-16 pt-8 border-t border-white/10 text-center">
            <p className="text-white/60 text-sm">
              Last updated: March 27, 2026. For any queries, contact us at <a href="mailto:contact@hackaccino.in" className="text-[#E61933] hover:underline">contact@hackaccino.in</a>
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsAndConditionsPage;
